<template>
    <div class="order-detail-section mg20">
        <h3>合同附件</h3>
        <div class="order-userInfo">
            <div class="userInfo-wrapper">
                <el-row class="userInfo-group">
                    合同编号：{{order.contract_number}}
                </el-row>
                <el-row class="userInfo-group" v-for="item in order.contracts" :key="item.id">
                    <el-row>
                        <el-col :span="12" class="order-item">合同名：<a :href="item.url" target="_blank"><i
                                class="el-icon-document"></i>{{item.name}}</a></el-col>
                    </el-row>
                </el-row>
                <el-row class="userInfo-group" v-if="order.contracts && order.contracts.length>0">
                    合同上传时间：{{_.first(order.contracts).created_at}}
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props:{
            order:{
                required: true
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_contract.vue